import { addHours, startOfMinute, subHours, subMinutes } from 'date-fns'

import { DatePreset } from 'modules/Monitoring/components/Filters/RangeFilter/RangeFilterContent'
import { pluralize } from 'modules/Monitoring/utils/pluralize'

export const createNextHoursPreset = (hours: number): DatePreset => ({
  key: `next-${hours}-hours`,
  label: `Next ${hours} hours`,
  getValue: () => {
    const now = startOfMinute(new Date())
    return {
      from: now,
      to: addHours(now, hours),
    }
  },
})

export const createLastMinutesPreset = (minutes: number): DatePreset => ({
  key: `last-${minutes}-minutes`,
  label: `Last ${minutes} min`,
  getValue: () => {
    const now = startOfMinute(new Date())
    return {
      from: subMinutes(now, minutes),
      to: now,
    }
  },
})

export const createLastHoursPreset = (hours: number): DatePreset => ({
  key: `last-${hours}-hours`,
  label: `Last ${pluralize('hour', hours)}`,
  getValue: () => {
    const now = startOfMinute(new Date())
    return {
      from: subHours(now, hours),
      to: now,
    }
  },
})
